<template>
  <div class="moow-master-container">
    <!-- <nav-default></nav-default> -->
    <div v-if="loadingDeal" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <b-container class="dashboard-container moow-resp-container" v-else>
      <b-row class="item-overview-container" v-if="!showDealEditDialog">
        <!-- <b-col xl="0" lg="0" md="0" sm="1" cols="1" v-if="narrowWidth"></b-col> -->
        <b-col sm="12" cols="12">
          <md-card class="island-card">
            <md-card-header style="height: 90pt;">
              <b-row v-if="!dealDisplayMarkers.bookingStatusTitle">
                <b-col md="6" cols="10">
                  <md-progress-bar md-mode="indeterminate"></md-progress-bar>
                </b-col>
              </b-row>
              <div v-else>
                <p class="md-title">{{dealDisplayMarkers.bookingStatusTitle}}</p>
                <p class="moow-info-txt large">{{dealDisplayMarkers.bookingStatusDesc}}</p>
              </div>
              <md-speed-dial
                md-direction="bottom"
                class="deal-speeddial"
                v-if="dealDisplayMarkers.isImport && ownerViewing"
              >
                <md-speed-dial-target
                  v-if="userRoleCanEditDeal"
                  class="md-icon-button md-dense md-primary play-cta-button makeup"
                >
                  <md-icon>more_vert</md-icon>
                </md-speed-dial-target>

                <md-speed-dial-content>
                  <md-button class="md-icon-button" @click="showDeleteConfirmation=true">
                    <md-icon>delete_forever</md-icon>
                    <md-tooltip md-direction="right" md-delay="0">Deletes also snapshots!</md-tooltip>
                  </md-button>
                </md-speed-dial-content>
              </md-speed-dial>
            </md-card-header>

            <md-card-content>
              <div v-if="!snapshots || snapshots.length === 0"></div>
              <div v-else>
                <b-row v-if="snapshots.length > 0">
                  <b-col>
                    <md-button
                      :class="getHistoryChipClass(snap)"
                      :md-ripple="false"
                      @click="selectChip(snap)"
                      v-for="(snap, index) in snapshots"
                      :key="snap._id+index"
                    >{{getSnapChipName(snap, index)}}</md-button>

                    <md-button
                    :class="getHistoryChipClass()"
                    md-clickable
                    :md-ripple="false"
                    @click="selectChip()"
                    >{{i18n_local.current}}</md-button>
                    
                  </b-col>
                </b-row>
                <span class="moow-info-txt small"><i>{{i18n_local.deal.deal_snapshot_desc}}</i></span>
              </div>
            </md-card-content>

            <md-card-actions md-alignment="space-between">
              <div style="padding: 1em">
                <moow-button
                  v-if="ownerViewing && showConfirmationButtons && userRoleCanEditDeal"
                  :type="['light']"
                  btnText="Accept"
                  tooltip="Proceed with contract"
                  @mClick="handleOnAccept"
                />
                <moow-button
                  v-if="ownerViewing && showConfirmationButtons && userRoleCanEditDeal"
                  :type="['dark', 'outlined', 'flat']"
                  btnText="Decline"
                  tooltip="Cannot be undone, tenant will be notified and declined"
                  @mClick="askDeclineConfimation"
                />
                <moow-button
                  v-if="ownerViewing && deal.lesseeAccountId && showConfirmationButtons"
                  :type="['dark', 'outlined']"
                  :btnText="i18n_local.tenantProfile"
                  class="ml-3"
                  @mClick="navigateToUserProfile(deal.lesseeAccountId)"
                  tooltip="Go to tenant public profile"
                />
                <moow-button
                  v-else-if="ownerViewing && !showConfirmationButtons && !deal.lesseeAccountId && !dealDisplayMarkers.isBookingDead && userRoleCanEditDeal"
                  :type="['dark', 'outlined']"
                  :btnText="tenantInvitationButtonText"
                  @mClick="inviteTenant()"
                  :disabled="disableTenantInvite"
                  tooltip="Tenant could see this info on his own dashboard"
                />
                <moow-button
                  v-if="ownerViewing && !showConfirmationButtons && !dealDisplayMarkers.isBookingDead && userRoleCanEditDeal"
                  :type="['light', 'link']"
                  btnText="Edit deal"
                  @mClick="startToSnapshotDeal()"
                />
              </div>
            </md-card-actions>
          </md-card>
        </b-col>
        <!-- <b-col xl="0" lg="0" md="0" sm="1" cols="1" v-if="narrowWidth"></b-col> -->
      </b-row>

      <b-row class="item-overview-container" v-if="dealDisplayMarkers.isBookingDead">
        <b-col sm="12" cols="12">
          <md-card class="island-card" v-if="dealDisplayMarkers.isImport">
            <md-card-header>
              <div class="md-title">{{dealDisplayMarkers.bookingStatusTitle}}</div>
            </md-card-header>

            <md-card-content>{{dealDisplayMarkers.bookingStatusDesc}}</md-card-content>
          </md-card>
        </b-col>
      </b-row>

      <b-row class="item-overview-container" v-if="showDealEditDialog">
        <b-col sm="12" cols="12">
          <!-- DEAL SNAPSHOT -->
          <md-card class="island-card" v-if="showDealEditDialog">
            <md-card-header>
              <div class="md-title">Edit Deal</div>
            </md-card-header>
            <md-card-content>
              <md-card class="attention-card md-primary island-card">
                <div class="md-layout">
                  <div class="md-layout-item md-size-10">
                    <md-button class="md-icon-button md-raised md-primary">
                      <md-icon>notification_important</md-icon>
                    </md-button>
                  </div>
                  <div class="md-layout-item md-size-90">
                    <span>Rembember that most changes will result in a new contract document being created.</span>
                    <span>Ending a termless contract with move out dates will not alter the contract document or its signatures.</span>
                  </div>
                </div>
              </md-card>
              <p
                class="moow-info-txt"
              >A snapshot is made of the deal and its related contract(s) so your data never gets lost.</p>
              <b-row>
                <b-col>
                  <div v-if="dealSnapshot.contractDetails">
                    <!-- {{dealSnapshot.contractDetails.terms}} -->
                    <div class="md-title">Dates</div>

                    <date-input
                      ref="dateInputFormRef_periodStart"
                      :date="dealSnapshot.contractDetails.terms.periodStart"
                      title="Move In"
                    />
                    <md-checkbox
                      v-if="dealSnapshot.contractDetails.terms.termless"
                      v-model="edit_noticeGiven"
                    >Notice Given</md-checkbox>

                    <b-row>
                      <b-col>
                        <date-input
                          v-if="edit_noticeGiven"
                          class="mt-3 date-input-in-dialog"
                          ref="dateInputFormRef_noticeGivenAt"
                          :date="dealSnapshot.contractDetails.terms.noticeGivenAt"
                          title="Notice Given At"
                        />
                      </b-col>
                    </b-row>

                    <b-row v-if="edit_noticeGiven">
                      <b-col xs="12" md="3">
                        <md-field :class="{ 'md-invalid': edit_noticePeriod_monthsErr }">
                          <label>Notice Period</label>
                          <md-input v-model="edit_noticePeriod_months" type="number"></md-input>
                          <span class="md-helper-text">Months</span>
                          <span class="md-error">{{edit_noticePeriod_monthsErr}}</span>
                        </md-field>
                      </b-col>
                    </b-row>

                    <date-input
                      :readonly="edit_noticeGiven && edit_noticeGiven"
                      v-if="dealSnapshot.contractDetails.terms.periodEnd"
                      class="mt-3 date-input-in-dialog"
                      ref="dateInputFormRef_periodEnd"
                      :date="dealSnapshot.contractDetails.terms.periodEnd"
                      title="Move out"
                    />
                  </div>
                </b-col>
              </b-row>

              <b-row v-if="dealSnapshot.contractDetails">
                <b-col>
                  <div class="md-title">House Rules</div>
                  <house-rules
                    ref="houseRulesFormRef"
                    :readonly="false"
                    :rules="dealSnapshot.contractDetails.houseRules"
                  />
                </b-col>
              </b-row>
              <md-divider class="mb-3" />

              <b-row v-if="dealSnapshot.contractDetails">
                <b-col cols="6">
                  <div class="md-title">Guests</div>
                  <!--<guests-selector-->
                  <!--ref="guestsSelectorRef"-->
                  <!--:guests="dealSnapshot.contractDetails.guests"-->
                  <!--:readonly="false"-->
                  <!--&gt;</guests-selector>-->
                  <guests-block v-model="guests"></guests-block>
                </b-col>
              </b-row>
              <md-divider class="mb-3" />

              <b-row>
                <b-col>
                  <div class="md-title">Editor Note</div>
                  <md-field>
                    <label>Leave a note on this edit</label>
                    <md-input
                      v-model="snapshotComment"
                      placeholder="e.g Parties are not allowed anymore."
                    ></md-input>
                  </md-field>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <div class="md-title">Effective date</div>
                  <md-datepicker
                    md-immediately
                    v-model="snapshotInEffect"
                    class="hide-input-clear-x"
                  >
                    <label>Changes in effect from</label>
                  </md-datepicker>
                </b-col>
              </b-row>

              <b-row class="mt-5">
                <b-col>
                  <p class="moow-info-txt small">
                    <i>To change property, a new deal must be created.</i>
                  </p>
                  <md-button
                    @click="cancelSnapshot()"
                    class="md-primary play-cta-button-flat grey"
                  >Cancel</md-button>
                  <md-button
                    @click="saveDealSnapshot()"
                    class="md-primary play-cta-button makeup"
                  >Update Deal</md-button>
                </b-col>
              </b-row>
            </md-card-content>
          </md-card>
        </b-col>
      </b-row>

      <b-row class="item-overview-container" v-else>
        <b-col xl="0" lg="0" md="0" sm="1" cols="1" v-if="narrowWidth"></b-col>
        <b-col xl="7" lg="7" md="7" sm="12" cols="12">
          <md-card class="island-card" v-if="dealDisplayMarkers.showRepeatPayment">
            <md-card-header>
              <div class="md-title">{{i18n_local.deal.booking_application_fee}}</div>
              <p class="payment-information-txt">
                {{i18n_local.deal.finalize_booking_fee}}
                <br />
                {{i18n_local.deal.charge_of_booking_fee_of}} {{bookingFeeAmount}} EUR.
              </p>
            </md-card-header>
            <md-card-content>
              <div
                v-if="loadingPaymentOptions"
                class="loader-rolling-local_blue"
                style="width: 25px;"
              ></div>
              <div v-else>
                <b-row class="payments-container">
                  <b-col
                    class="payment-container"
                    v-for="(bankLinkOption, id) in bankLinkOptions"
                    :key="id"
                  >
                    <a :href="bankLinkOption.url">
                      <div
                        class="payment-option"
                        v-bind:style="{ 'background-image': 'url(' + bankLinkOption.logo_url + ')' }"
                      ></div>
                    </a>
                  </b-col>
                </b-row>
              </div>
            </md-card-content>
          </md-card>

          <md-card class="island-card">
            <md-card-header>
              <div class="md-title">{{i18n_local.payment_timeline}}</div>
            </md-card-header>
            <md-card-content>
              <payment-timeline
                :terms="deal.contractDetails.terms"
                :dueNow="dueNow"
                :showBookingFee="!ownerViewing"
              ></payment-timeline>
            </md-card-content>
          </md-card>
          <md-card class="island-card">
            <md-card-header>
              <div class="md-title">
                 <moow-button
                  :type="['link', 'dark']"
                  :btnText="i18n_local.tenant"
                  :camel="true"
                  @mClick="navigateToUserProfile(deal.lesseeAccountId)"
                  tooltip="Go to tenant public profile"
                />
              </div>
              <!-- <p class="moow-info-txt">Private person</p> -->
            </md-card-header>
            <md-card-content>
              <b-row v-if="deal.lesseeDet.privatePerson">
                <b-col>
                  <moow-button
                    v-b-toggle.collapse-3
                    :type="['dark', 'outlined', 'flat']"
                    btnText="Person details"
                  />
                  <!-- <md-button
                    v-b-toggle.collapse-3
                    class="md-primary play-cta-button-flat makeup"
                  >Person details</md-button>-->
                  <b-collapse id="collapse-3">
                    <b-card>
                      <person-view
                        :personId="deal.lesseeDet.privatePerson._id"
                        personType="private"
                      ></person-view>
                    </b-card>
                  </b-collapse>
                </b-col>
              </b-row>
              <b-row v-if="deal.lesseeDet.jurPerson">
                <b-col>
                  <moow-button
                    class="mt-2"
                    v-b-toggle.collapse-4
                    :type="['dark', 'outlined', 'flat']"
                    btnText="Company details"
                  />

                  <b-collapse id="collapse-4">
                    <b-card>
                      <person-view :personId="deal.lesseeDet.jurPerson._id" personType="juridical"></person-view>
                    </b-card>
                  </b-collapse>
                </b-col>
              </b-row>
            </md-card-content>
          </md-card>

          <md-card class="island-card" v-if="deal.lessorDet">
            <md-card-header>
              <div class="md-title">{{i18n_local.landlord.landlord}}</div>
            </md-card-header>
            <md-card-content>
              <b-row>
                <b-col>
                  <moow-button
                    v-b-toggle.collapse-5
                    :type="['dark', 'outlined', 'flat']"
                    btnText="Representative"
                  />
                  <b-collapse id="collapse-5">
                    <b-card>
                      <person-view :personId="deal.lessorDet.repPrivPersonId" personType="private"></person-view>
                    </b-card>
                  </b-collapse>
                </b-col>
              </b-row>
            </md-card-content>
          </md-card>
          <md-card class="island-card">
            <md-card-header>
              <div class="md-title">{{capitalize(i18n_local.house_rules)}}</div>
            </md-card-header>
            <md-card-content>
              <house-rules
                :selectable="false"
                ref="houseRulesFormRef"
                :rules="deal.contractDetails.houseRules"
              />
            </md-card-content>
          </md-card>

          <md-card class="island-card" v-if="ownerViewing">
            <md-card-header>
              <div class="md-title">{{i18n_local.private_notes}}</div>
            </md-card-header>
            <md-card-content>
              <md-tabs class="play-tabs white" md-elevation="2">
                <md-tab id="property-notes-tab" md-label="Property Notes">
                  <listing-notes v-if="deal && deal.property" :listing-id="deal.property.maaklerID"></listing-notes>
                </md-tab>
                <md-tab id="deal-notes-tab" md-label="Deal Notes">
                  <listing-deal-notes
                    v-if="deal && deal.property && selectedAccountId"
                    :deal-id="deal._id"
                    :account-id="selectedAccountId"
                  ></listing-deal-notes>
                </md-tab>
              </md-tabs>
            </md-card-content>
          </md-card>

          <md-card class="island-card" v-if="ownerViewing">
            <md-card-header>
              <div class="md-title">Files</div>
            </md-card-header>
            <md-card-content>
              <listing-deal-files v-if="selectedAccountId" :account-id="selectedAccountId"></listing-deal-files>
            </md-card-content>
          </md-card>
        </b-col>

        <b-col xl="1" lg="1" md="0" sm="0" cols="0" v-if="!narrowWidth"></b-col>

        <b-col xl="4" lg="4" md="5" class="right-side-container" v-if="!narrowWidth">
          <!-- If the deal is actually a snapshot -->
          <md-card class="island-card" v-if="deal.snapshotId">
            <md-card-header>
              <div class="md-title">Snapshot</div>
            </md-card-header>
            <md-card-content v-if="snapshotInView">
              <!-- {{snapshotInView}} -->
              <md-list>
                <md-list-item>
                  <md-icon>file_copy</md-icon>
                  <div class="md-list-item-text">
                    <span>{{deal.snapshotId}}</span>
                    <span>ID</span>
                  </div>
                </md-list-item>
                <md-list-item>
                  <md-icon>edit</md-icon>
                  <div class="md-list-item-text">
                    <span>{{formatDateToDisplayDate(snapshotInView.createdAt)}}</span>
                    <span>Created At</span>
                  </div>
                </md-list-item>
                <md-list-item v-if="snapshotInView.comment">
                  <md-icon>comment_bank</md-icon>
                  <div class="md-list-item-text">
                    <span>
                      {{snapshotInView.comment}}
                      <md-tooltip md-direction="bottom">{{snapshotInView.comment}}</md-tooltip>
                    </span>
                    <span>Editor Note</span>
                  </div>
                </md-list-item>
                <md-list-item v-if="snapshotInView.inEffectDate">
                  <md-icon>calendar_today</md-icon>
                  <div class="md-list-item-text">
                    <span>{{formatDateToDisplayDate(snapshotInView.inEffectDate)}}</span>
                    <span>Changes in effect from</span>
                  </div>
                </md-list-item>
              </md-list>
            </md-card-content>
          </md-card>

          <!-- THIRD-PARTY SIGNATURE TRACKING -->
          <md-card
            class="island-card"
            v-if="thirdPartySignatureProcessingUsed"
            v-show="!deal.snapshotId"
          >
            <md-card-header>
              <div class="md-title">{{i18n_local.contract}}</div>
              <!-- <p class="moow-info-txt" v-if="contractData.name">{{ contractData.name }}</p> -->
              <div v-if="dealDocumentsRequestPending">
                <!--!contractData.name-->
                <md-progress-bar md-mode="indeterminate"></md-progress-bar>
                <p>
                  <i>Fetching contract, may take a minute</i>
                </p>
              </div>
            </md-card-header>
            <md-card-content>
              <md-list v-if="contractData.name">
                <md-list-item>
                  <md-icon>grading</md-icon>
                  <div class="md-list-item-text">
                    <span v-if="contractData.name">{{ contractData.name }}</span>
                    <md-tooltip md-direction="bottom">Contract ID: {{ contractData.contractId }}</md-tooltip>
                  </div>
                </md-list-item>
                <md-list-item
                  v-if="!contractData.signatures || contractData.signatures.length == 0"
                >
                  <md-icon>fingerprint</md-icon>
                  <div class="md-list-item-text">
                    <span class="moow-info-txt">Unsigned</span>
                  </div>
                </md-list-item>
                <md-list-item v-else v-for="signature in contractData.signatures" :key="signature">
                  <md-icon>fingerprint</md-icon>
                  <div class="md-list-item-text">
                    <span>{{ signature.name }}</span>
                    <span>{{ signature.ssn }}</span>
                  </div>
                </md-list-item>
              </md-list>
              <md-list v-else>
                <md-list-item>
                  <md-icon>search</md-icon>
                  <div class="md-list-item-text">
                    <span>Fetching contract</span>
                    <div class="loader-rolling-local_blue"></div>
                  </div>
                </md-list-item>
              </md-list>
            </md-card-content>
            <md-card-actions>
              <!-- <img :src="downloadPDFIcon" alt="PDF" @click="downloadContractPDF()"/> -->
              <moow-button
                  v-if="contractData.link"
                  :type="['light']"
                  btnText="SIGN NOW"
                  tooltip="Review and sign the contract"
                  @mClick="openLink(contractData.link)"
                />
            </md-card-actions>
          </md-card>

          <!-- ACCOMODATION AGREEMENT SIGNATURE TRACKING -->
          <md-card class="island-card" v-else-if="deal.contractType === 'tcAgreement' || selectedContractType === 'tcAgreement'">
            <md-card-header>
              <div class="md-title">{{i18n_local.contract}}</div>
              <!-- <p class="moow-info-txt secondary">Contract is signed using the Accomodation Agreement</p> -->
            </md-card-header>
            <md-card-content>
              <accomodation-signatures
                :accountId="selectedAccountId"
                :lessor="ownerViewing"
                :legalParams="legalParams"
              />
            </md-card-content>
          </md-card>

          <!-- MANUAL SIGNATURE TRACKING -->
          <md-card class="island-card" v-else-if="!showConfirmationButtons">
            <md-card-header>
              <div class="md-title">{{capitalize(i18n_local.contract)}}</div>
              <p class="moow-info-txt secondary">Track signatures manually</p>
            </md-card-header>
            <md-card-content>
              <contract-signatures
                ref="contractSignaturesRef"
                :dealId="deal._id"
                :dealSnapshotId="snapshotInViewId"
                :readonly="!userRoleCanEditDeal"
                :accountId="selectedAccountId"
                @emitNotifyMessage="notifyMessage"
                @emitSignaturesUpdated="signaturesUpdatedHandler"
                @emitToggleLoading="signaturesLoadingHandler"
              />
            </md-card-content>
          </md-card>

          <md-card class="island-card">
            <md-card-header>
              <div class="md-title">{{capitalize(i18n_local.property)}}</div>
            </md-card-header>
            <md-card-content>
              <property-summary :maaklerID="deal.property.maaklerID" />
            </md-card-content>
          </md-card>

          <md-card class="island-card">
            <md-card-header>
              <div class="md-title">{{capitalize(i18n_local.terms)}}</div>
            </md-card-header>
            <md-card-content>
              <deal-terms-list :terms="deal.contractDetails.terms" />
            </md-card-content>
          </md-card>

          <md-card class="island-card">
            <md-card-header>
              <div class="md-title">{{capitalize(i18n_local.guests)}}</div>
            </md-card-header>
            <md-card-content>
              <b-row id="booking-guest-details">
                <b-col>
                  <b-row
                    class="table-item"
                    v-for="(guest, index) in deal.contractDetails.guests"
                    :key="index"
                  >
                    <md-list>
                      <md-list-item>
                        <md-icon>person</md-icon>
                        <span class="md-list-item-text" v-if="guest.name">{{guest.name}}</span>
                        <span class="md-list-item-text" v-else>Ananymous</span>
                      </md-list-item>
                    </md-list>
                  </b-row>
                </b-col>
              </b-row>
            </md-card-content>
          </md-card>
        </b-col>

        <md-dialog :md-active.sync="showTenantAltEmailDialog" md-fullscreen>
          <md-dialog-title>Confirm tenant email</md-dialog-title>
          <md-dialog-content>
            <p>After tenant has accepted the invitation, he will get access to this deal dashboard as well as receive the tenant guides specified under the property manage view.</p>
            <md-field :class="{ 'md-invalid': tenantInviteEmailErr }">
              <label>Tenant email</label>
              <md-input v-model="tenantInviteEmail"></md-input>
              <span class="md-error">{{tenantInviteEmailErr}}</span>
            </md-field>
          </md-dialog-content>
          <md-dialog-actions>
            <md-button class="md-primary" @click="showTenantAltEmailDialog = false">Cancel</md-button>
            <md-button class="md-primary" @click="confirmInviteTenant()">Invite</md-button>
          </md-dialog-actions>
        </md-dialog>

        <moow-dialog-confirm
          title="Decline this booking?"
          content="Once declined, tenant will be notified and application removed. This action cannot be undone!"
          confirmText="Decline"
          cancelText="Wait"
          :showDialog="showDeclineConfirmation"
          @mConfirm="declineBooking"
          @mCancel="showDeclineConfirmation=false"
        />

        <moow-dialog-confirm
          title="Accept this booking?"
          content="Once accepted, automatic contract can be generated and if tenant is not connected to this Deal, one can be invited."
          confirmText="Accept"
          cancelText="Wait"
          :showDialog="showAcceptConfirmation"
          @mConfirm="askContractType"
          @mCancel="showAcceptConfirmation=false"
        />

        <md-dialog
          :md-active.sync="contractTypeSelectionDialogOpened"
          :md-close-on-esc="false"
          @md-closed="contractTypeSelectionDialogOpened = false"
        >
          <contract-type-selection-dialog
            :account-id="selectedAccountId"
            :short-booking-period="shortBookingPeriod"
            :allowContractTemplates="allowContractTemplates"
            :legalParams="legalParams"
            @typeChosen="onContractTypeSelected"
            @emitToggleSupportChat="openSupportChat"
            @closed="contractTypeSelectionDialogOpened = false"
          ></contract-type-selection-dialog>
        </md-dialog>

        <moow-dialog-confirm
          title="Delete this deal?"
          content="Deleting a deal will also delete its snapshots and related calendar entries!"
          confirmText="Delete"
          :showDialog="showDeleteConfirmation"
          @mConfirm="deleteDeal"
          @mCancel="showDeleteConfirmation=false"
        />

        <md-button
          class="md-fab md-primary float-abs-top-right"
          v-if="narrowWidth"
          @click="showBookingDetailsDrawer = true"
        >
          <md-icon>chevron_left</md-icon>
        </md-button>

        <md-snackbar :md-active.sync="showSnackbar" md-persistent>
          <span>{{snackbarMessage}}!</span>
          <md-button class="md-accent" @click="snackbarCTA()">{{snackbarCTATxt}}</md-button>
        </md-snackbar>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ContractSignatures from "@/components/contracts/contractSignatures.vue";
import ContractTypeSelectionDialog from "@/components/contracts/dialogs/ContractTypeSelectionDialog.vue";
import PersonView from "@/components/person/personView.vue";
import { formatTimeToMonDD } from "../../functions.js";
import { mapGetters } from "vuex";
import {
  BOOKING_STATUS,
  BOOKING_PAYMENT_STATUS,
  BOOKING_CONTRACT_STATUS,
  askBookingApplicationFeePayment,
  shouldShowPaymentDetails,
  isBookingDead,
  isBookingPendingForOwnerConfirmation,
  getDealDescriptions,
} from "../../bookings/bookingUtil.js";
import {
  getUserPaymentDetails
} from "../../users/repositories/userRepository.js";
import CapacityPreview from "../../components/listingComponents/propertyCapacityPreview.vue";
import PropertyTechDetails from "../../components/listingComponents/propertyTechnicalDetails.vue";
import PaymentTimeline from "@/components/payments/dealPaymentTimeline.vue";
import DateInput from "@/components/utils/dateInput.vue";
import { downloadContract } from "../../contracts/services/contractService.js";
import HouseRules from "@/components/listingComponents/houseRulesSelector.vue";
import PropertySummary from "@/components/property/propertySummary.vue";
import {
  formatISOShortToDDMonthYYYY,
  formatDateToString,
} from "@/timeFunctions.js";
import { startBookingApplicationTransaction } from "../../payments/paymentService";
import { makeBookingConfirmationDecision } from "../../bookings/bookingsService.js";
import moment from "moment";
import GuestsBlock from "@/components/bookings/deals/GuestsBlock.vue";
import DealTermsList from "@/components/bookings/deals/dealTermsList.vue";
import DealContentProvider from "@/platform/deals/services/DealContentProvider";
import ListingNotes from "@/components/listingNotes.vue";
import ListingDealNotes from "@/components/listingDealNotes.vue";
import ListingDealFiles from "@/components/listingDealFiles.vue";
import ContractDocumentService from "@/services/contract-documents";
import AccomodationSignatures from "@/components/contracts/accomodationSignatures.vue"
import { getPrivatePerson } from "@/platform/person/repository/personRepository.js";

const SIGNATURES_REQUEST_TIMEOUT = 2000;

export default {
  props: {
    dealId: {
      type: String,
      required: false,
    },
    snapshotId: {
      type: String,
      required: false,
    },
    ownerViewingForced: {
      type: Boolean,
      required: false,
    },
    redirect: {
      type: String,
      required: false,
    },
  },
  components: {
    DealTermsList,
    CapacityPreview,
    HouseRules,
    PropertyTechDetails,
    PaymentTimeline,
    PropertySummary,
    PersonView,
    ContractSignatures,
    DateInput,
    GuestsBlock,
    ListingNotes,
    ListingDealNotes,
    ListingDealFiles,
    ContractTypeSelectionDialog,
    AccomodationSignatures,
  },
  data() {
    return {
      allowDelete: false,
      deleteConfirm: "delete",
      expandTenant: false,
      expandLandlord: false,
      showDealEditDialog: false,
      showStatusCtaDialog: false,
      bookingFeeAmount: undefined,
      loadingPaymentOptions: true,
      bankLinkOptions: [],
      showSnackbar: false,
      snackbarCTATxt: "",
      snackbarCode: undefined,
      snackbarMessage: "",
      showBookingDetailsDrawer: false,
      narrowWidth: false,
      bookingStatusTitle: "",
      bookingStatusDesc: "",
      bookingPaymentTitle: "Make First Payment",
      ownerBankAccount: "",
      ownerBankSwift: "",
      ownerBank: "",
      accountHolderName: "",
      paymentDesc: "",
      paymentAmount: "",
      loadingListing: true,
      loadingOwner: true,
      loadingOwnerPaymentDetails: true,
      listingSafe: {},
      otherPartySafe: {},
      bookingSafe: undefined,
      isBookingDead: true,
      showRules: false,
      cannotLoadOwnerPaymentDetails: false,
      showPaymentDetails: false,
      otherPartyUid: "",
      showDeclineConfirmation: false,
      showAcceptConfirmation: false,
      showDeleteConfirmation: false,
      selectedContractType: "",
      selectedContractTemplateId: "",
      edit_noticeGiven: false,
      edit_noticePeriod_months: undefined,
      edit_noticePeriod_monthsErr: undefined,
      snapshotComment: "",
      snapshotInEffect: undefined,
      dealDisplayMarkers: {
        isBookingDead: false,
        showPaymentDetails: false,
        showRepeatPayment: false,
        bookingStatusTitle: "",
        bookingStatusDesc: "",
        isImport: false,
      },
      loadingDisplayMarkers: true,
      contentProvider: undefined,
      contractTypeSelectionDialogOpened: false,
      contractData: {
        contractId: "",
        name: "",
        link: "",
        signatures: [],
      },
      tenantInviteEmail: "",
      tenantInviteEmailErr: "",
      showTenantAltEmailDialog: false,
      tenantInvitationButtonText: "",
      legalParams: {},
      tenantJustInvited: false,
      dealDocumentsRequestPending: false,
      guests: [],
    }; 
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    downloadPDFIcon() {
      return require("../../assets/icons/download_pdf.svg");
    },
    disableTenantInvite() {
      if (this.tenantJustInvited) return true;
      if (!this.deal) return true;
      if (this.deal.tenantInvited) return true;
      else return false;
    },
    currentUserRole() {
      return this.$store.getters.userRoleInAccount;
    },
    currentUserUid() {
      if (this.$store.getters.user) return this.$store.getters.user.uid;
      else return false;
    },
    allowContractTemplates() {
      try {
        //TODO: replace w/ commented for testing
        // return true
        var allow = true;
        if (!this.deal.type || this.deal.type == "import") allow = false;
        if (!this.deal.contractDetails.terms.monthly) allow = false;
        return allow;
      } catch (err) {
        return false;
      }
    },
    userRoleCanViewNotes() {
      if (!this.currentUserRole) return false;
      else if (
        this.$store.getters.accountWriteRoles.includes(this.currentUserRole)
      )
        return true;
      return false;
    },
    userRoleCanEditDeal() {
      if (!this.currentUserRole) return false;
      else if (
        this.$store.getters.dealNoteWriteRoles.includes(this.currentUserRole)
      )
        return true;
      return false;
    },
    accountPaymentDetails() {
      return this.$store.getters.accountPaymentDetails;
    },
    dueNow() {
      if (this.dealDisplayMarkers.showRepeatPayment) return "booking";
      else return "before";
    },
    dealSnapshot() {
      return this.$store.getters.dealSnapshotInEdit;
    },
    snapshotInViewId() {
      if (this.snapshotInView) return this.snapshotInView._id;
      return undefined;
    },
    snapshotInView() {
      if (!this.deal) return null;
      // the deal in view, is actually a snapshot
      if (this.deal.snapshotId && this.snapshots) {
        for (var i = 0; i < this.snapshots.length; i++) {
          if (this.snapshots[i]._id == this.deal.snapshotId)
            return this.snapshots[i];
        }
      }
      return null;
    },
    snapshots() {
      return this.$store.getters.dealSnapshots(this.dealId);
      // if (this.$store.getters.dealSnapshots[this.dealId])
      //   return this.$store.getters.dealSnapshots[this.dealId];
      // return [];
    },
    selectedAccountId() {
      if (this.$store.getters.connectedAccountIds.length > 0)
        return this.$store.getters.connectedAccountIds[0];
      return null;
    },
    loadingDeal() {
      return this.$store.getters.loadingDealInView;
    },
    deal() {
      if(this.$store.getters.dealInView && this.$store.getters.dealInView.lessorAccountId === this.selectedAccountId) this.ownerViewing = true
      else this.ownerViewing = false
      return this.$store.getters.dealInView;
    },
    placeholder() {
      return require("../../assets/listing-hero-placeholder.png");
    },
    showConfirmationButtons() {
      if (this.deal && isBookingPendingForOwnerConfirmation(this.deal))
        return true;
      else return false;
    },
    dealCriticalErr() {
      return this.$store.getters.dealCriticalErr;
    },
    thirdPartySignatureProcessingUsed() {
      if (!this.deal) {
        return false;
      }
      if (this.deal.contractTemplateId || this.selectedContractTemplateId) {
        return true;
      }

      return false;
    },
    contractDataValid() {
      const validContractTypes = ["contract", "manual", "tcAgreement"];
      if (!validContractTypes.includes(this.selectedContractType)) {
        return false;
      }

      return !(
        this.selectedContractType === "contract" &&
        !this.selectedContractTemplateId
      );
    },
    shortBookingPeriod() {
      if (!this.deal) {
        return false;
      }
      const {
        contractDetails: { terms: { periodStart, periodEnd } = {} } = {},
      } = this.deal;
      if (!periodStart || !periodEnd) {
        return false;
      }

      return (
        Math.floor((new Date(periodEnd) - new Date(periodStart)) / 86400000) <
        90
      );
    },
  },
  watch: {
    i18n_local: function (val) {
      this.contentProvider = new DealContentProvider(val);
    },
    dealCriticalErr: function (val) {
      if (val) {
        this.goBack();
      }
    },
    deleteConfirm: function (val, oldVal) {
      if (val == "delete") this.allowDelete = true;
      else this.allowDelete = false;
    },
    selectedAccountId: function (val, oldVal) {
      if (val) this.setDisplayMarkers();
    },
    deal: function (val, oldVal) {
      if (val) {
        this.getDealDocuments();
        this.setDisplayMarkers();
        this.collectLegalParams();
      }
    },
    // snapshotInViewId: function(val, oldVal){
    //   if(val && val != oldVal){
    //     this.loadingDisplayMarkers = true;
    //   }
    // },
    "dealSnapshot.snapshotId": function (val, oldVal) {
      if (this.dealSnapshot && this.dealSnapshot.contractDetails) {
        this.dealSnapshot.contractDetails.terms.noticeGivenAt
          ? (this.edit_noticeGiven = true)
          : (this.edit_noticeGiven = false);
        this.edit_noticePeriod_months = this.dealSnapshot.contractDetails.terms.noticePeriod_months;
      }
    },
    dealSnapshot: function (snapshot) {
      this.guests = [...snapshot.contractDetails.guests];
    },
  },
  mounted() {},
  created() {
    this.$emit("emitCustomAction", {action:"hideSideMenu"});
    if (this.ownerViewingForced == true || this.ownerViewingForced == false) {
      this.ownerViewing = this.ownerViewingForced;
    }
    ContractDocumentService.subscribe(
      this.selectedAccountId,
      (message) => {
        if (message.event !== "dealContractCreated" || !message.data.documentId) {
          return;
        }
        this.contractData.contractId = message.data.documentId || "";
        this.contractData.name = message.data.name || "";
        this.contractData.link = message.data.link || "";
        setTimeout(
          async () => {
            try {
              const signatures = await ContractDocumentService.getContractSignatures(
                message.data.documentId
              );
              this.contractData.signatures = this.mapSignatures(signatures);
            } catch (error) {
              console.error(error);
            } finally {
              this.signaturesLoadingHandler(false);
              this.signaturesUpdatedHandler({});
            }
          },
          SIGNATURES_REQUEST_TIMEOUT,
        );
      }
    );

    if (this.dealId) {
      this.$store.dispatch("getDealInView", {
        dealId: this.dealId,
        snapshotId: this.snapshotId,
      });
    } else this.goBack();

    this.contentProvider = new DealContentProvider(this.i18n_local);
    if (
      this.dealSnapshot &&
      this.dealSnapshot.contractDetails &&
      this.dealSnapshot.contractDetails.terms.noticeGivenAt
    )
      this.edit_noticeGiven = true;
    if (
      this.dealSnapshot &&
      this.dealSnapshot.contractDetails &&
      this.dealSnapshot.contractDetails.terms.noticePeriod_months
    )
      this.edit_noticePeriod_months = this.dealSnapshot.contractDetails.terms.noticePeriod_months;

    this.tenantInvitationButtonText = "Invite tenant";
    if (this.deal.tenantInvited) this.tenantInvitationButtonText = "Invited";


    if (this.dealSnapshot && this.dealSnapshot.contractDetails) {
      this.guests = [...this.dealSnapshot.contractDetails.guests];
    }
    this.setDisplayMarkers();
    this.getDealDocuments();
  },
  methods: {
    downloadContractPDF(){
      // TODO: not working yes. Blob is malformed as PDF
      try{
        const blob = new Blob([this.contractData.blob], { type: 'application/pdf' });
        const fileName = "Contract.pdf"
        const link = document.createElement('a');
        // create a blobURI pointing to our Blob
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        // some browser needs the anchor to be in the doc
        document.body.append(link);
        link.click();
        link.remove();
        // in case the Blob uses a lot of memory
        setTimeout(() => URL.revokeObjectURL(link.href), 7000);
      }catch(ex){
        console.log("downloadContractPDF > ex: ", ex)
      }
    },
    navigateToUserProfile(tenantUid) {
      let routeData = this.$router.resolve({
        name: "user",
        params: { id: tenantUid }
      });
      window.open(routeData.href, "_blank");
    },
    // navigateToUserProfile(tenantUid) {
    //   if (!tenantUid) return;
    //   try {
    //     this.navigateTo({
    //       where: "user",
    //       params: { id: tenantUid }
    //     });
    //   } catch (err) {
    //   }
    // },
    navigateTo({ where, params }) {
      this.$router.push({
        name: where,
        params: params
      });
    },
    inviteTenant() {
      if (!this.deal) return;
      if (this.deal.lesseeDet && this.deal.lesseeDet.privatePerson)
        this.tenantInviteEmail = this.deal.lesseeDet.privatePerson.email;
      this.showTenantAltEmailDialog = true;
    },
    confirmInviteTenant() {
      try {
        if (!this.tenantInviteEmail) {
          this.tenantInviteEmailErr = "Required";
          return;
        }
        var tenantAltEmail = this.tenantInviteEmail;
        this.deal.tenantInvited = true;
        this.tenantInvitationButtonText = "Invited";
        this.tenantJustInvited = true;
        var inviteeName =
          this.deal.lesseeDet.privatePerson.givenName +
          " " +
          this.deal.lesseeDet.privatePerson.surname;
        this.$store.dispatch("inviteTenantToDeal", {
          inviteeName: inviteeName,
          inviterUid: this.currentUserUid,
          dealId: this.deal._id,
          tenantAltEmail: tenantAltEmail,
          accountId: this.selectedAccountId,
        });
      } catch (err) {
        console.log("confirmInviteTenant > err:", err);
      } finally {
        this.showTenantAltEmailDialog = false;
      }
    },
    openSupportChat(value) {
      this.$emit("emitToggleSupportChat", value);
    },
    openLink(link) {
      window.open(link, "_blank");
    },
    setDisplayMarkers() {
      if (this.deal) {
        var dealPaymentStatus = this.getDealPaymentStatus(this.deal);
        var signatures = { lessee: false, lessor: true };
        if (this.$refs.contractSignaturesRef) signatures = this.$refs.contractSignaturesRef.getCurrentSignatures();
        
        this.dealDisplayMarkers = this.getStatusValues({
          paymentStatus: dealPaymentStatus,
          signatures: signatures,
          deal: this.deal
        });

        if (
          this.dealDisplayMarkers.showRepeatPayment &&
          this.deal &&
          this.deal._id &&
          this.selectedAccountId
        )
          this.getBookingApplicationPaymentOptions(
            this.deal._id,
            this.selectedAccountId
          );
      }
    },
    signaturesUpdatedHandler({ lessee, lessor }) {
      this.setDisplayMarkers();
    },
    signaturesLoadingHandler(isLoading) {
      this.loadingDisplayMarkers = isLoading;
    },
    getValidSnapshotFromForm() {
      var contractDetails = this.$store.getters.dealSnapshotInEdit
        .contractDetails;
      const periodStart = this.$refs.dateInputFormRef_periodStart.getValidDate();

      var periodEnd;
      if (this.$refs.dateInputFormRef_periodEnd)
        periodEnd = this.$refs.dateInputFormRef_periodEnd.getValidDate();

      var noticeGivenAt;
      if (this.edit_noticeGiven) {
        if (!this.edit_noticePeriod_months) {
          this.edit_noticePeriod_monthsErr = "Required";
          return false;
        }
        if (this.$refs.dateInputFormRef_noticeGivenAt)
          noticeGivenAt = this.$refs.dateInputFormRef_noticeGivenAt.getValidDate();
      }

      if (
        this.edit_noticeGiven &&
        this.edit_noticePeriod_months &&
        noticeGivenAt
      ) {
        var nDate = moment(noticeGivenAt);
        nDate.add(this.edit_noticePeriod_months, "months");
        periodEnd = formatDateToString(nDate, "YYYY-MM-DD");
      }

      var houseRules = this.$refs.houseRulesFormRef.getRules();

      if (periodStart && periodEnd != false && noticeGivenAt != false) {
        contractDetails.terms.periodStart = periodStart;
        periodEnd ? (contractDetails.terms.periodEnd = periodEnd) : void 0;
        contractDetails.terms.noticeGivenAt = noticeGivenAt;
        contractDetails.terms.noticePeriod_months = this.edit_noticePeriod_months;
        contractDetails.houseRules = houseRules;
        contractDetails.guests = this.guests;

        var updates = { contractDetails: contractDetails };
        this.$store.commit("UPDATE_DEAL_SNAPSHOT_IN_EDIT_ROOTS", updates);
        return true;
      } else return false;
    },
    startToSnapshotDeal() {
      // make a copy of the deal
      const ss = JSON.parse(JSON.stringify(this.deal));
      this.$store.commit("SET_DEAL_SNAPSHOT_IN_EDIT", ss);

      // update map
      if (this.dealSnapshot && this.dealSnapshot.contractDetails) {
        this.dealSnapshot.contractDetails.terms.noticeGivenAt
          ? (this.edit_noticeGiven = true)
          : (this.edit_noticeGiven = false);

        this.edit_noticePeriod_months = this.dealSnapshot.contractDetails.terms.noticePeriod_months;
      }

      // show edit dialog
      if (Object.keys(this.dealSnapshot).length > 0)
        this.showDealEditDialog = true;
    },
    deleteDeal() {
      if (this.dealDisplayMarkers.isImport) {
        this.$store.dispatch("deleteDealInView", { dealId: this.deal._id });
        this.redirectTo({ where: "deals" });
      }
      return;
    },
    applySnapshotEdits() {
      this.getValidSnapshotFromForm();
    },
    saveDealSnapshot() {
      if (this.getValidSnapshotFromForm()) {
        this.$store
          .dispatch("createSnapshot", {
            dealId: this.deal._id,
            snapshot: this.$store.getters.dealSnapshotInEdit,
            comment: this.snapshotComment,
            inEffectDate: this.snapshotInEffect,
          })
          .catch((error) => {
            this.notifyError(
              "Server error",
              "Deal updating was not performed correctly"
            );
          });
        this.showDealEditDialog = false;
      }
    },
    cancelSnapshot() {
      // this.dealSnapshot = {}
      this.$store.commit("SET_DEAL_SNAPSHOT_IN_EDIT", {});
      this.showDealEditDialog = false;
    },
    formatDateToDisplayDate(d) {
      return formatDateToString(d, "DD MMM YYYY");
    },
    getSnapChipName(snap, snapIndex) {
      if (snap.createdAt) {
        return formatDateToString(snap.createdAt, "DD MMM YYYY");
      } else if (snap.comment) {
        return snap.comment;
      } else {
        return "older";
      }
    },
    getHistoryChipClass(snap) {
      // If selected
      if (!snap && this.deal && !this.deal.snapshotId)
        return "md-raised md-primary"; // original selected
      if (snap && this.deal && snap._id == this.deal.snapshotId)
        return "md-raised md-primary";
      else return "md-raised";
    },
    selectDeal({ dealId, snapshotId }) {
      this.$store.dispatch("getDealInView", {
        dealId: dealId,
        snapshotId: snapshotId,
      });
    },
    selectChip(snapshot) {
      var sid;
      snapshot ? (sid = snapshot._id) : void 0;
      this.selectDeal({ dealId: this.dealId, snapshotId: sid });
    },
    paymentDetailsSet() {
      if (
        !this.accountPaymentDetails.accountHolderName ||
        !this.accountPaymentDetails.ibanCode
      ) {
        this.notifyActionMessage(
          this.i18n_local.guide.add_account_payment,
          this.i18n_local.add,
          1
        );
        return false;
      }
      return true;
    },
    snackbarCTA() {
      if (this.snackbarCode == 1)
        this.redirectTo({
          where: "account",
          params: {
            postSaveRedirect: "deal",
            returnToDealId: this.dealId,
            openWithTab: "tab-payment",
            ownerViewing: this.ownerViewing,
          },
        });
    },
    notifyActionMessage(message, ctaTxt, code) {
      (this.showSnackbar = true), (this.snackbarMessage = message);
      this.snackbarCTATxt = ctaTxt;
      this.snackbarCode = code;
    },
    askDeclineConfimation() {
      this.showDeclineConfirmation = true;
    },
    handleOnAccept() {
      if (!this.paymentDetailsSet()) return;
      this.askContractType();
    },
    async getPrivatePerson ({ repPrivPersonId = '', ownerPersonId = '', ownerPersonType = '' }) {
        if (repPrivPersonId) {
            return await getPrivatePerson({ id: repPrivPersonId });
        }
        if (ownerPersonType === 'private' && ownerPersonId) {
            return await getPrivatePerson({ id: ownerPersonId });
        }

        return null;
    },
    async collectLegalParams() {
        try {
            const {
                lessorDet: {
                    repPrivPersonId,
                    ownerPersonId,
                    ownerPersonType,
                } = {},
                lesseeDet: {
                    privatePerson: {
                        givenName = '',
                        surname = '',
                    } = {},
                } = {},
                property: {
                    address: {
                        formattedAD = '',
                    } = {},
                } = {},
            } = this.deal || {};

            const privatePerson = await this.getPrivatePerson({ repPrivPersonId, ownerPersonId, ownerPersonType });
            let ownerName = '';
            if (privatePerson) {
                ownerName = `${this.capitalize(privatePerson.givenName)} ${this.capitalize(privatePerson.surname)}`;
            }

            this.legalParams = {
                ownerName: ownerName,
                tenantName: `${this.capitalize(givenName)} ${this.capitalize(surname)}`, // givenName + surname,
                property: formattedAD,
            };
        }
        catch (error) {
            console.error(error);
        }
    },
    capitalize(string) {
        if (!string) {
            return '';
        }

        return string[0].toUpperCase() + string.substr(1);
    },
    askContractType() {
      this.contractTypeSelectionDialogOpened = true;
    },
    async onContractTypeSelected(data) {
      try {
          this.selectedContractType = data.type;
          this.selectedContractTemplateId = data.templateId;
          this.loadingDisplayMarkers = true;
          await this.acceptBooking();
          if (data.type !== 'tcAgreement') {
              return;
          }
          await this.onAccomodationAgreementAccepted();
      }
      catch (error) {
          console.error(error);
      }
      finally {
          this.loadingDisplayMarkers = false;
      }
    },
    declineBooking() {
      if (this.deal._id) {
        makeBookingConfirmationDecision({
          bookingId: this.deal._id,
          decision: "decline",
          propertyId: this.deal.propertyId,
          bookingType: this.deal.type,
        });
        this.$store.commit("UPDATE_BOOKING_STATUS", {
          dealId: this.deal._id,
          status: BOOKING_STATUS.declined,
        });
      }
      this.setDisplayMarkers();

      this.showDeclineConfirmation = false;
    },
    acceptBooking() {
      if (!this.paymentDetailsSet()) {
        return;
      }
      if (!this.deal._id || !this.contractDataValid) {
        this.notifyMessage("Select contract template to continue!");
        return;
      }

      makeBookingConfirmationDecision({
        bookingId: this.deal._id,
        decision: "accept",
        contractType: this.selectedContractType,
        contractTemplateId: this.selectedContractTemplateId,
        propertyId: this.deal.propertyId,
        accountId: this.selectedAccountId,
        bookingType: this.deal.type,
      });
      this.$store.commit("UPDATE_BOOKING_STATUS", {
        dealId: this.deal._id,
        status: BOOKING_STATUS.accepted,
      });
      this.setDisplayMarkers();
      this.showAcceptConfirmation = false;
    },
    getLessorPaymentDetails(lessorAccountId) {},
    getSetOwnerPaymentDetails(ownerUid) {
      this.loadingOwnerPaymentDetails = true;
      getUserPaymentDetails(ownerUid)
        .then((result) => {
          if (result) this.mapOwnerPaymentDetails(result);
          else this.cannotShowOwnerPaymentDetails("no result");
        })
        .catch((error) => {
          this.cannotShowOwnerPaymentDetails(error);
        });
    },
    cannotShowOwnerPaymentDetails(errorMsg) {
      this.cannotLoadOwnerPaymentDetails = true;
      this.loadingOwnerPaymentDetails = false;
    },
    downloadContractDocument() {
      downloadContract(this.bookingSafe.contractDefReq.documentNameInBucket);
    },
    getBookingApplicationPaymentOptions(dealId, accountId) {
      console.log('getBookingApplicationPaymentOptions');
      
      this.loadingPaymentOptions = true;
      startBookingApplicationTransaction({ dealId, accountId })
        .then((response) => {
          this.populatePaymentOptions(response);
        })
        .catch((err) => {
          console.log(err)
          this.loadingPaymentOptions = false;
          this.notifyError("Cannot get payment options");
        });
    },
    populatePaymentOptions(transaction) {
      this.bookingFeeAmount = transaction.amount;
      this.bankLinkOptions = transaction.payment_methods.banklinks;
      this.loadingPaymentOptions = false;
    },
    mapOwnerPaymentDetails(paymentDetails) {
      try {
        this.ownerBankAccount = paymentDetails.ibanCode;
        this.ownerBankSwift = paymentDetails.swiftCode;
        this.ownerBank = paymentDetails.bankName;
        this.accountHolderName = paymentDetails.accountHolderName;
      } catch (err) {
        this.cannotShowOwnerPaymentDetails(err);
      }
      this.cannotLoadOwnerPaymentDetails = false;
      this.loadingOwnerPaymentDetails = false;
    },
    getDealPaymentStatus(deal) {
      var paymentStatus = this.getOverwritePaymentStatusFromProp(); //if there is status in props, we will overwrite the booking.status.
      if (paymentStatus) {
        if (paymentStatus === "COMPLETED")
          return BOOKING_STATUS.payment_success;
        else if (paymentStatus === "REFUNDED")
          return BOOKING_PAYMENT_STATUS.payment_refunded;
        else if (paymentStatus === "CANCELLED")
          return BOOKING_PAYMENT_STATUS.payment_cancelled;
      } else if (deal) return deal.paymentStatus;
      else return "";
    },
    getStatusValues({paymentStatus, signatures, deal}) {
      var res = {
        isBookingDead: true,
        showPaymentDetails: false,
        showRepeatPayment: false,
        bookingStatusTitle: "",
        bookingStatusDesc: "",
        isImport: false,
      };
      if (deal.type == "import") res.isImport = true;
      res.isBookingDead = isBookingDead(deal);
      res.showPaymentDetails = shouldShowPaymentDetails({
        paymentStatus: paymentStatus,
        deal: deal,
        ownerViewing: this.ownerViewing
      });

      res.showRepeatPayment = askBookingApplicationFeePayment(
        deal,
        this.ownerViewing
      );
    console.log('res.showRepeatPayment: ', res.showRepeatPayment)
      if (!this.contentProvider) this.contentProvider = new DealContentProvider(this.i18n_local);
      var titleNDesc = this.contentProvider.getDealDescriptions({status: deal.status, paymentStatus: paymentStatus, contractStatus: deal.contractStatus});

      res.bookingStatusTitle = titleNDesc.title;
      if (this.ownerViewing) res.bookingStatusDesc = titleNDesc.ownerDesc;
      else res.bookingStatusDesc = titleNDesc.tenantDesc;

      return res;
    },
    getOverwritePaymentStatusFromProp() {
      if (this.paymentStatus) return this.paymentStatus;
      else return false;
    },
    goBack() {
      var name = "";
      if (this.redirect) name = this.redirect;
      else name = "dashboard";
      this.redirectTo({ where: name });
    },
    redirectTo({ where, params }) {
      this.$router.push({
        name: where,
        params: params,
      });
    },
    reloadBooking() {},
    notifyError(title, msg) {
      this.$notify({
        title: title,
        message: msg,
      });
    },
    notifyMessage(message) {
      this.snackbarMessage = message;
      this.showSnackbar = true;
    },
    formatTimeToDDMMYYGate(date) {
      return formatTimeToMonDD(date);
    },
    handleWindowResize() {
      this.narrowWidth = window.innerWidth <= 990;
    },
    async getDealDocuments() {
      if (
        this.deal.status !== BOOKING_STATUS.accepted ||
        this.dealDocumentsRequestPending
      ) {
        return;
      }
      try {
        this.dealDocumentsRequestPending = true;
        const data =
          (await ContractDocumentService.getDocumentForDeal(this.deal._id)) ||
          {};
        if (!data.documentId) {
          return;
        }

        this.contractData.contractId = data.documentId || "";
        this.contractData.name = data.name || "";
        this.contractData.link = data.link || "";
        setTimeout(
          async () => {
            try {
              const signatures = await ContractDocumentService.getContractSignatures(data.documentId);
              this.contractData.signatures = this.mapSignatures(signatures);
            } catch (error) {
              console.error(error);
            } finally {
              this.signaturesLoadingHandler(false);
              this.signaturesUpdatedHandler({});
            }
          },
          SIGNATURES_REQUEST_TIMEOUT,
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.dealDocumentsRequestPending = false;
      }
    },
    mapSignatures(signatures) {
      if (!Array.isArray(signatures) || !signatures.length) {
        return [];
      }

      return signatures.map((signature) => ({
        name: signature.name,
        ssn: signature.ssn,
        signedAt: moment(signature.signed_at).format("DD.MM.YYYY HH:mm:ss"),
      }));
    },
    async onAccomodationAgreementAccepted() {
        if(!this.currentUserUid || !this.selectedAccountId) {
            return;
        }
        if (!this.deal || !this.deal._id) {
            return;
        }
        const command = {
            dealId: this.deal._id,
            signerType: 'lessor',
            signerAccountId: this.selectedAccountId,
            signerUid: this.currentUserUid,
            legalParams: this.legalParams,
        };

        await this.$store.dispatch("signDealAccomodationAgreement", command);
    },
  },
};
</script>
<style scoped>
@import "../../assets/styles/booking.css";
@import "../../assets/styles/dashboard.css";
@import "../../assets/styles/global.css";
@import "../../assets/styles/listings-view.css";

.date-input-in-dialog {
  z-index: 9999;
}
.deal-speeddial {
  position: absolute;
  right: 1em;
  top: 1em;
}

.booking-request-content-container {
  padding: 1em;
}

.payment-container {
  margin: 10px;
}

.payment-option {
  height: 62px;
  width: 156px;
  background-repeat: no-repeat;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/bookings/Booking.vue